import styled from "@emotion/styled";

export const HeroSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: clamp(300px, 40vw, 600px);

  h1 {
    font-size: clamp(25px, 5vw, 46px);
    font-weight: 800;
    line-height: 1.2;
    margin: 0;
    color: white;
  }

  p {
    font-size: clamp(16px, 2.5vw, 23px);
    color: #ccc3c3ff;
    line-height: 1.5;
  }
`;
